import type { PaymentMethod } from "@/components/landing/Payments/types";
import PaymentMethodMark from "@/components/landing/Payments/PaymentMethodMark";

interface PaymentMethodsRowProps {
	methods: PaymentMethod[];
}

function PaymentMethodsRow(prop: PaymentMethodsRowProps) {
	const { methods } = prop;
	return (
		<div className="mt-9 flex flex-wrap items-center gap-3 border-t border-border pt-7">
			{methods.map((method) => (
				<span
					key={method.id}
					title={method.desc}
					className="flex items-center gap-2 rounded-xl border border-border bg-surface px-3 py-2 text-sm font-medium"
				>
					<PaymentMethodMark id={method.id} />
					{method.title}
				</span>
			))}
		</div>
	);
}

export default PaymentMethodsRow;
